// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from '../../utils/axios';
import { dispatch } from '../index';
import {API} from "aws-amplify";

const apiName = process.env.REACT_APP_ENDPOINT_NAME;
const path_get_bank_summary = process.env.REACT_APP_DASHBOARD_GET_BANK_SUMMARY;
const path_get_trial_balance = process.env.REACT_APP_DASHBOARD_GET_TRIAL_BALANCE;
const path_get_executive_summary = process.env.REACT_APP_DASHBOARD_GET_EXECUTIVE_SUMMARY;
const path_get_accounts_payables = process.env.REACT_APP_DASHBOARD_GET_ACCOUNTS_PAYABLES;
const path_get_accounts_receivables = process.env.REACT_APP_DASHBOARD_GET_ACCOUNTS_RECEIVABLES;
const path_get_employees_data = process.env.REACT_APP_DASHBOARD_GET_EMPLOYEES_DATA;
const path_get_connections_list = process.env.REACT_APP_DASHBOARD_GET_CONNECTIONS_LIST;
const path_post_send_invoice_email = process.env.REACT_APP_DASHBOARD_POST_INVOICE_EMAIL;
const path_get_merger_accounts = process.env.REACT_APP_DASHBOARD_GET_MERGER_ACCOUNTS;
const path_get_merger_trial_balance = process.env.REACT_APP_DASHBOARD_GET_MERGER_TRIAL_BALANCE;

const initialState={
    error: null,
    bankClosingBalanceSummary: null,
    BankSummaryReportDate: null,
    net_profit: null,
    trial_balance_report_date: null,
    summary_data: [],
    summary_headers: [],
    executive_summary_report_date: null,
    accounts_payables_list: [],
    total_amount_paid: 0,
    amount_paid_list: [],
    total_amount_due: 0,
    amount_due_list: [],
    total_amount: 0,
    total_amount_list: [],
    over_90_days_due_amount: 0,
    between_60_90_days_due_amount: 0,
    less_then_60_days_due_amount: 0,
    accounts_receivables_list: [],
    total_amount_received: 0,
    amount_received_list: [],
    total_amount_owed: 0,
    amount_owed_list: [],
    total_amount_receivable: 0,
    total_amount_receivable_list: [],
    over_90_days_receivable_amount: 0,
    between_60_90_days_receivable_amount: 0,
    less_then_60_days_receivable_amount: 0,
    employee_leave_balances: [],
    employee_leave_applications: [],
    connections_list_subscription: null,
    send_invoice_email_success: null,
    merger_org_selected: null,
    merger_accounts: {},
    merger_accounts_mapping: {},
    merger_trial_balance: {},
    orgToDisplay: '',
    report_date: new Date()
}

const slice = createSlice({
    name: 'dashboard',
    initialState,
    reducers:{
        handlerResetSendInvoiceEmailSuccess(state, action){
          state.send_invoice_email_success=action.payload.send_invoice_email_success;
          return state
        },
        handlerResetMergerData(state, action){
          state.merger_org_selected = action.payload.merger_org_selected;
          state.merger_accounts = action.payload.merger_accounts;
          state.merger_accounts_mapping = action.payload.merger_accounts_mapping;
          state.merger_trial_balance = action.payload.merger_trial_balance;
          state.orgToDisplay = action.payload.orgToDisplay;
          return state
        },
        handlerSetOrdToDisplay(state, action){
            state.orgToDisplay = action.payload.orgToDisplay;
            return state
        },
        handlerSetMergerOrgSelected(state, action){
            console.log(action);
            state.merger_org_selected=action.payload.merger_org_selected;
            state.merger_accounts={};
            state.merger_accounts_mapping={};
            state.merger_trial_balance={};
            state.orgToDisplay='';
        },
        handlerSetMergerMapping(state, action) {
          console.log(action);
          state.merger_accounts_mapping[action.payload.source_account_id]=action.payload.merger_account_id;
        },
        handlerSetDateSelected(state, action){
            state.report_date=action.payload.report_date;
        },
        hasError(state, action) {
            console.log(state);
            state.error = action.payload;
        },
        getTrialBalanceSuccess(state, action){
            state.trial_balance_report_date = action.payload.data.reportDate;
            state.net_profit = action.payload.data.net_profit;
            return state
        },
        getBankSummarySuccess(state, action){
            state.bankClosingBalanceSummary = action.payload.data.bankClosingBalanceSummary;
            state.BankSummaryReportDate = action.payload.data.reportDate;
            return state
        },
        getExecutiveSummarySuccess(state, action){
            state.summary_data = action.payload.data.summary_data;
            state.summary_headers = action.payload.data.summary_headers;
            state.executive_summary_report_date= action.payload.data.reportDate;
            return state
        },
        getAccountsPayablesSuccess(state, action){
            state.accounts_payables_list = action.payload.data.accounts_payables_list;
            state.total_amount_paid = action.payload.data.total_amount_paid;
            state.amount_paid_list = action.payload.data.amount_paid_list;
            state.total_amount_due = action.payload.data.total_amount_due;
            state.amount_due_list = action.payload.data.amount_due_list;
            state.total_amount = action.payload.data.total_amount;
            state.total_amount_list = action.payload.data.total_amount_list;
            state.over_90_days_due_amount = action.payload.data.over_90_days_due_amount;
            state.between_60_90_days_due_amount = action.payload.data.between_60_90_days_due_amount;
            state.less_then_60_days_due_amount = action.payload.data.less_then_60_days_due_amount;
            return state;
        },
        getAccountsReceivablesSuccess(state, action){
            state.accounts_receivables_list = action.payload.data.accounts_receivables_list;
            state.total_amount_received = action.payload.data.total_amount_received;
            state.amount_received_list = action.payload.data.amount_received_list;
            state.total_amount_owed = action.payload.data.total_amount_owed;
            state.amount_owed_list = action.payload.data.amount_owed_list;
            state.total_amount_receivable = action.payload.data.total_amount_receivable;
            state.total_amount_receivable_list = action.payload.data.total_amount_receivable_list;
            state.over_90_days_receivable_amount = action.payload.data.over_90_days_receivable_amount;
            state.between_60_90_days_receivable_amount = action.payload.data.between_60_90_days_receivable_amount;
            state.less_then_60_days_receivable_amount = action.payload.data.less_then_60_days_receivable_amount;
            return state;
        },
        getEmployeesDataSuccess(state, action){
            state.employee_leave_balances = action.payload.data.employee_leave_balances;
            state.employee_leave_applications = action.payload.data.employee_leave_applications;
            return state;
        },
        getConnectionsListSuccess(state, action){
            state.connections_list_subscription = action.payload.data.connections_list;
        },
        getMergerAccountsSuccess(state, action){
            state.merger_accounts = action.payload.data.merger_accounts;
            state.merger_accounts_mapping = JSON.parse(action.payload.data.merger_account_mapping);
        },
        getMergerTrialBalanceSuccess(state, action){
          state.merger_trial_balance = action.payload.data.merger_trial_balance;
        },
        postSendInvoiceEmailSuccess(state, action){
            state.send_invoice_email_success = action.payload.send_invoice_email_success;
            return state;
        }
    }
});

export default slice.reducer;

export function getBankSummary(username, subscription_id){
  return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "username": JSON.stringify(username),
        "subscription_id": subscription_id
      }
    }
    API.get(apiName, path_get_bank_summary, myInit)
        .then(response => {
            dispatch(slice.actions.getBankSummarySuccess(response.data))
        }).catch(error => {
            dispatch(slice.actions.hasError(error))
    })
  };
}

export function getConnectionsList(username, subscription_id){
  return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "username": JSON.stringify(username),
        "subscription_id": subscription_id
      }
    }
    API.get(apiName, path_get_connections_list, myInit)
        .then(response => {
            dispatch(slice.actions.getConnectionsListSuccess(response.data))
        }).catch(error => {
            dispatch(slice.actions.hasError(error))
    })
  };
}

export function getMergerTrialBalance(username, subscription_id, merger_tenant_id, merger_accounts, report_date){
    return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "username": JSON.stringify(username),
        "subscription_id": subscription_id,
        "merger_tenant_id": merger_tenant_id,
        "merger_accounts": merger_accounts,
        "report_date": report_date
      }
    }
    API.get(apiName, path_get_merger_trial_balance, myInit)
        .then(response => {
            dispatch(slice.actions.getMergerTrialBalanceSuccess(response.data))
        }).catch(error => {
            dispatch(slice.actions.hasError(error))
    })
  };
}

export function getMergerAccounts(username, subscription_id, merger_tenant_id){
  return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "username": JSON.stringify(username),
        "subscription_id": subscription_id,
        "merger_tenant_id": merger_tenant_id
      }
    }
    API.get(apiName, path_get_merger_accounts, myInit)
        .then(response => {
            dispatch(slice.actions.getMergerAccountsSuccess(response.data))
        }).catch(error => {
            dispatch(slice.actions.hasError(error))
    })
  };
}

export function getTrialBalance(username, subscription_id){
    return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "username": JSON.stringify(username),
        "subscription_id": subscription_id
      }
    }
    API.get(apiName, path_get_trial_balance, myInit)
        .then(response => {
            dispatch(slice.actions.getTrialBalanceSuccess(response.data))
        }).catch(error => {
            dispatch(slice.actions.hasError(error))
    })
  };
}

export function getExecutiveSummary(username, subscription_id){
    return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "username": JSON.stringify(username),
        "subscription_id": subscription_id
      }
    }
    API.get(apiName, path_get_executive_summary, myInit)
        .then(response => {
            dispatch(slice.actions.getExecutiveSummarySuccess(response.data))
        }).catch(error => {
            dispatch(slice.actions.hasError(error))
    })
  };
}

export function getAccountsPayables(username, subscription_id){
    return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "username": JSON.stringify(username),
        "subscription_id": subscription_id
      }
    }
    API.get(apiName, path_get_accounts_payables, myInit)
        .then(response => {
            dispatch(slice.actions.getAccountsPayablesSuccess(response.data))
        }).catch(error => {
            console.log("Accounts Payables error")
            dispatch(slice.actions.hasError(error))
    })
  };
}

export function getAccountsReceivables(username, subscription_id){
    return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "username": JSON.stringify(username),
        "subscription_id": subscription_id
      }
    }
    API.get(apiName, path_get_accounts_receivables, myInit)
        .then(response => {
            dispatch(slice.actions.getAccountsReceivablesSuccess(response.data))
        }).catch(error => {
            console.log("Accounts Payables error")
            dispatch(slice.actions.hasError(error))
    })
  };
}

export function getEmployeesData(username, subscription_id){
    return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "username": JSON.stringify(username),
        "subscription_id": subscription_id
      }
    }
    API.get(apiName, path_get_employees_data, myInit)
        .then(response => {
            dispatch(slice.actions.getEmployeesDataSuccess(response.data))
        }).catch(error => {
            console.log("Accounts Payables error")
            dispatch(slice.actions.hasError(error))
    })
  };
}

export function postSendInvoiceEmail(selected_tenant, username, invoice_id){
    return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      body: {
        selected_tenant, username, invoice_id
      }
    }
    API.post(apiName, path_post_send_invoice_email, myInit)
        .then(response => {
            dispatch(slice.actions.postSendInvoiceEmailSuccess(response.data))
        }).catch(error => {
            dispatch(slice.actions.hasError(error))
    })
  };
}

export const {handlerResetSendInvoiceEmailSuccess, handlerSetMergerOrgSelected, handlerSetMergerMapping, handlerSetDateSelected, handlerResetMergerData, handlerSetOrdToDisplay} = slice.actions;